import { useSpring } from '@react-spring/web';

const useBounce = () => {
  const [style, api] = useSpring(() => ({
    from: { transform: 'translateY(0px)' },
    config: { tension: 500, friction: 50 }
  }));

  const startBounce = () => {
    api.start({
      from: { transform: 'translateY(0px)' },
      to: async (next) => {
        while (1) {
          await next({ transform: 'translateY(-10px)' })
          await next({ transform: 'translateY(0px)' })
        }
      }
    });
  };

  const stopBounce = () => {
    api.stop();
    api.start({ transform: 'translateY(0px)' });
  };

  return { style, startBounce, stopBounce };
};

export default useBounce;